<template>
  <v-dialog v-model="cancelWarningModal" max-width="400px">
    <span class="link" slot="activator">
       <slot></slot>
     </span>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="headline-20">Qual foi o motivo do cancelamento?</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn class="ma-0" icon @click.native="cancelWarningModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <p style="font-size:16px;">Escolha um motivo para o cancelamento</p>
        <v-radio-group v-model="reason" :mandatory="false">
          <v-radio v-for="reason in reasons" color="red" :label="reason.description" :key="reason.id"  :value="reason.id"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat="flat" :disabled="reason === null" @click.native="cancelSchedule">Sim, desejo cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'cancel-warning',
  data () {
    return {
      cancelWarningModal: false,
      reason: null
    }
  },
  methods: {
    cancelSchedule () {
      if (this.reason === null) {
        this.$store.commit('toastr', {
          color: 'warning',
          texto: 'Insira um motivo'
        })
      } else {
        this.cancelWarningModal = false
        this.$store.commit('updateReason', this.reason)
        this.$store.dispatch('cancelSchedule')
      }
    }
  },
  computed: {
    reasons () {
      return this.$store.getters.reasons
    }
  },
  mounted () {
    this.reason = this.$store.getters.selectedSchedule.idReason
    this.$store.dispatch('getReasons')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.headline-20{
  font-size: 16px;
  font-weight: 400;
  line-height: 32px !important;
  letter-spacing: normal !important;
}

@media (min-width: 440px)  {
  .headline-20{    
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// cancelWarning.vue?093a8277